module.exports = __webpack_public_path__ + "7749b163ab9db78e5ee20c137b269c88.svg";